module.exports = __webpack_public_path__ + "static/media/river_level_alert_small.0df3818b.png";